module.exports = __webpack_public_path__ + "img/编组9.cca611b1.png";